export const projectCalendarEnUS = {
  calendar: 'Calendar',
}

export const projectCalendarEsMX = {
  calendar: 'Calendario',
}
